import { getImagePath } from '@/utils/imageUtils';
import React from 'react';

interface ImageProps {
  className?: string;
  alt?: string;
  src: string;
  withPublicPath?: boolean;
  draggable?: boolean;
  [key: string]: any;
}

/**
 * img 组件封装，用于显示接口配置的图片url，支持：
 * 1、Path 模式时自动支持 Path；
 * 2、自动判断图片的路径是相对路径还是 URL；
 * 3、支持内部资源、外部资源以及 Base64；
 */
const Image: React.FC<ImageProps> = ({
  className,
  src,
  alt,
  withPublicPath,
  draggable = false,
  ...props
}) => (
  <img
    className={className}
    src={getImagePath(src, withPublicPath)}
    {...props}
    alt={alt}
    draggable={draggable}
  />
);

export default React.memo(Image);
